module.exports = __webpack_public_path__ + "static/media/name-ico.26d717ad.svg";